import update from "immutability-helper";
import {
  SET_PROPERTY_SUSPECTS_LOADING,
  SET_PROPERTY_SUSPECTS_DATA,
  SET_PROPERTY_SUSPECTS_ERROR,
  SET_PROPERTY_SUSPECTS_CURSOR,
  SET_PROPERTY_SUSPECTS_HAS_NEXT_PAGE,
  SET_PROPERTY_SUSPECTS_TOTAL_COUNT,
  SET_PROPERTY_SUSPECTS_CRS_VALUES,
  RESET_PROPERTY_SUSPECTS
} from "../actions/propertySuspects";

const initialState = {
  isLoading: false,
  hotelData: [],
  error: null,
  cursor: null,
  hasNextPage: false,
  totalCount: 0,
  crsValues: []
};

export default function propertySuspects(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PROPERTY_SUSPECTS_LOADING:
      return update(state, {
        isLoading: { $set: action.isLoading }
      });

    case SET_PROPERTY_SUSPECTS_DATA:
      return update(state, {
        hotelData: { $set: action.data }
      });

    case SET_PROPERTY_SUSPECTS_ERROR:
      return update(state, {
        error: { $set: action.error }
      });

    case SET_PROPERTY_SUSPECTS_CURSOR:
      return update(state, {
        cursor: { $set: action.cursor }
      });

    case SET_PROPERTY_SUSPECTS_HAS_NEXT_PAGE:
      return update(state, {
        hasNextPage: { $set: action.hasNextPage }
      });

    case SET_PROPERTY_SUSPECTS_TOTAL_COUNT:
      return update(state, {
        totalCount: { $set: action.totalCount }
      });

    case SET_PROPERTY_SUSPECTS_CRS_VALUES:
      return update(state, {
        crsValues: { $set: action.crsValues }
      });

    case RESET_PROPERTY_SUSPECTS:
      return update(state, { $set: initialState });

    default:
      return state;
  }
}
